import Navigation from "@/components/Navigation";
import Hero from "@/components/Hero";
import About from "@/components/About";
import FoodGallery from "@/components/FoodGallery";
import Venue from "@/components/Venue";
import Menus from "@/components/Menus";
import Testimonials from "@/components/Testimonials";
import TourScheduler from "@/components/TourScheduler";
import BookingForm from "@/components/BookingForm";
import Footer from "@/components/Footer";

const Index = () => {
  return (
    <main className="min-h-screen">
      <Navigation />
      <Hero />
      <About />
      <FoodGallery />
      <Venue />
      <Menus />
      <Testimonials />
      <TourScheduler />
      <BookingForm />
      <Footer />
    </main>
  );
};

export default Index;
